import { QueryResult } from '@apollo/client';
import { Position } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { GroupPicker } from 'components';
import { useActiveMember } from 'hooks';
import useActivePosition from 'hooks/models/position/useActivePosition';
import _ from 'lodash';
import { getGraphQlEqualComparison } from 'utils/apolloUtils';
import { memberGroupQuery, memberGroupsQuery } from './employee-group-picker-queries';

export interface IEmployeeGroupPickerProps {
  value: string | null;
  filterByPermission: boolean;
  onSelect: (memberGroupId: string | null) => void;
  minWidth?: string; // has default
  className?: string | object;
  placeholder?: string;
  position?: Position;
  client?: any;
  disabled?: boolean;
  error?: boolean;
  fetchPolicy?: string;
  searchArchived?: boolean;
  autofocus?: boolean;
}

function EmployeeGroupPicker({ className, filterByPermission, onSelect, ...rest }: IEmployeeGroupPickerProps) {
  const activeMember = useActiveMember();
  const activePosition = useActivePosition();

  function queryResolver(result: QueryResult) {
    return result.data.memberGroups;
  }

  function singleQueryResolver(result: QueryResult) {
    return _.get(result, 'memberGroups[0][groupName]');
  }

  const classes = classNames('employee-picker', className);

  return (
    <GroupPicker
      query={memberGroupsQuery}
      filter={
        filterByPermission && activePosition?.scopeByGroup
          ? { id: getGraphQlEqualComparison(activeMember.memberGroupId) ?? null }
          : undefined
      }
      queryResolver={queryResolver}
      singleQueryResolver={singleQueryResolver}
      onSelect={onSelect}
      singleQuery={memberGroupQuery}
      className={classes}
      {...rest}
    />
  );
}

EmployeeGroupPicker.defaultProps = {
  filterByPermission: false,
};

export default EmployeeGroupPicker;
